import styled from 'styled-components'
import React from 'react'
import { useIntl } from 'react-intl'

const GetRewardInfo: React.FC = () => {
  const intl = useIntl()

  return (
    <GetRewardEmailContainer>
      <Info id='info'>
        <ul>
          <li className='firstLevel'>{intl.formatMessage({ id: 'GetReward.info.rvm' })}</li>
          <ul className='sublevel'>
            <li className='sublevel'>{intl.formatMessage({ id: 'GetReward.info.rvm.li1' })}</li>
            <li className='sublevel'>{intl.formatMessage({ id: 'GetReward.info.rvm.li2' })}</li>
          </ul>

          <li className='firstLevel'>{intl.formatMessage({ id: 'GetReward.info.sdm' })}</li>
          <ul className='sublevel'>
            <li className='sublevel'>{intl.formatMessage({ id: 'GetReward.info.sdm.li1' })}</li>
            <li className='sublevel'>{intl.formatMessage({ id: 'GetReward.info.sdm.li2' })}</li>
            <li className='sublevel'>{intl.formatMessage({ id: 'GetReward.info.sdm.li3' })}</li>
          </ul>

          <li className='firstLevel'>{intl.formatMessage({ id: 'GetReward.info.dropoff' })}</li>
          <li className='firstLevel'>{intl.formatMessage({ id: 'GetReward.info.reward' })}</li>
        </ul>
      </Info>
    </GetRewardEmailContainer>
  )
}

const GetRewardEmailContainer = styled.div`
  width: 100%;
`

const Info = styled.div`
  text-align: left;
  font-style: normal;
  font-weight: ${({ theme }) => theme.weight.light};
  font-size: ${({ theme }) => theme.size.small};
  color: ${({ theme }) => theme.color.black};
  font-family: ${({ theme }) => theme.font.default};
  margin-bottom: 14px;

  margin-left: 10px;

  li.firstLevel {
    list-style: disc;

    &:not(:last-child) {
      margin-bottom: 5px;
    }
  }

  li.sublevel {
    margin-left: 20px;
    list-style: circle;
  }

  ul.sublevel {
    &:not(:last-child) {
      margin-bottom: 5px;
    }
  }
`

export default GetRewardInfo
